import { Box } from '@mui/material';
import { Customer } from 'api/user-domain/user-domain.types';
import CustomerCreatedDate from 'pages/crm/customers/customer-details/customer-overview/customer-created-date/customer-created-date.component';
import CustomerLoyaltyPoints from 'pages/crm/customers/customer-details/customer-overview/customer-loyalty-points/customer-loyalty-points.component';
import { useCustomerOverviewExtendedAttributes } from 'pages/crm/customers/customer-details/customer-overview/customer-overview-extended-attributes/customer-overview-extended-attributes.hooks';
import CustomerOverviewExtendedAttributes from 'pages/crm/customers/customer-details/customer-overview/customer-overview-extended-attributes/customer-overview-extendend-attributes.component';

type CustomerQuickDetailsOverviewCardsProps = {
  customerData: Customer;
  confirmedPoints: number;
};

const CustomerQuickDetailsOverviewCards = ({
  customerData,
  confirmedPoints,
}: CustomerQuickDetailsOverviewCardsProps) => {
  const attributes = useCustomerOverviewExtendedAttributes(
    customerData?.extendedAttributes,
  );

  return (
    <Box display="grid" gridTemplateColumns="repeat(1, 1fr)" gap={2}>
      <CustomerCreatedDate createdDate={customerData?.createdDate} />
      <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={2}>
        <CustomerLoyaltyPoints confirmedPoints={confirmedPoints} />
        <CustomerOverviewExtendedAttributes attributes={attributes} />
      </Box>
    </Box>
  );
};

export default CustomerQuickDetailsOverviewCards;
